import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import { BrandEnum } from "src/app/classes/enums";

import { ImageResolverPipe } from "../../../pipes/sharedpipes/image-resolver.pipe";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-brand-card",
  templateUrl: "./brand-card.component.html",
  imports: [ImageResolverPipe, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandCardComponent implements OnInit {
  public BrandEnum: typeof BrandEnum = BrandEnum;
  brand = input.required<string>();

  constructor() {}

  ngOnInit(): void {}
}
